import classNames from "classnames";
import React from "react";
import { FlexBox } from "./FlexBox";

interface IProps {
  color?: "primary";
  size?: "sm" | "md";
}

export const ActivityIndicator = (props: IProps) => {
  return (
    <FlexBox alignItems="center" justifyContent="center">
      <svg
        className={classNames(
          "animate-spin -ml-1 mr-3",
          computeSize(props.size),
          props.color === "primary" ? "text-primary-900" : "text-white"
        )}
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
      >
        <circle
          className="opacity-25"
          cx="12"
          cy="12"
          r="10"
          stroke="currentColor"
          strokeWidth="4"
        ></circle>
        <path
          className="opacity-75"
          fill="currentColor"
          d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
        ></path>
      </svg>
    </FlexBox>
  );
};

const computeSize = (rounded?: IProps["size"]) => {
  switch (rounded) {
    case "sm":
      return "h-5 w-5";
    case "md":
      return "h-8 w-8";
    default:
      return "h-12 w-12";
  }
};
